import { useQuery } from 'react-query'
import { useMemo } from 'react'
import { indexAPI, indexAPITransformers } from './index-api'

export function useQueryNationalIndex(filter, enabled = true) {
  const NATIONAL_INDEX_ID = 0
  const queryInfo = useQuery(
    ['index', filter],
    () => indexAPI.getIndex(NATIONAL_INDEX_ID, filter),
    {
      refetchOnWindowFocus: false,
      enabled: enabled
    }
  )

  return {
    ...queryInfo,
    data: useMemo(
      () =>
        indexAPITransformers.indexValuesToChartData(
          queryInfo.data?.indexValues || []
        ),
      [queryInfo.data]
    )
  }
}
